import {
  type ILogbookSignersData,
  type ISignerConfig,
  type ISignerRow,
} from "./LogbookSigners.types";

const mapSelectOptions = (
  items: any[],
  valueKey: string,
  labelKey: string,
): Array<{ value: string; label: string }> =>
  items.map(item => {
    if (typeof item === "string") {
      return { value: item, label: item };
    }
    return {
      value: String(item[valueKey] ?? item.value ?? item.lbid ?? ""),
      label: String(
        item[labelKey] ?? item.label ?? item.lbname ?? item.name ?? "",
      ),
    };
  });

export const mapGetSigners = (res: any): ILogbookSignersData => {
  const data = res?.data;
  const logbooks = mapSelectOptions(data.logbooks ?? [], "lbid", "lbname");
  const roles = mapSelectOptions(
    data.roles ?? data.ranks ?? [],
    "rolename",
    "rolename",
  );
  const list: ISignerRow[] = data.signers ?? [];

  return { logbooks, roles, rows: list };
};

export const rowsToSavePayload = (rows: ISignerRow[]) => {
  const grouped = new Map<string, ISignerConfig[]>();

  rows.forEach(row => {
    if (!row.lbid) return;

    const signer: ISignerConfig = {
      name: row.name,
      pri: row.pri ?? [],
      priMandatory: row.priMandatory ?? false,
      sec: row.sec ?? [],
      secMandatory: row.secMandatory ?? false,
    };

    if (row.id != null) {
      signer.id = row.id;
    }

    const existing = grouped.get(row.lbid) ?? [];
    existing.push(signer);
    grouped.set(row.lbid, existing);
  });

  return {
    list: Array.from(grouped.entries()).map(([lbid, signers]) => ({
      lbid,
      signers,
    })),
  };
};

export const emptySignerRow = (): ISignerRow => ({
  name: "",
  lbid: "",
  pri: [],
  priMandatory: false,
  sec: [],
  secMandatory: false,
});
